/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable dot-notation */
/* eslint-disable react/no-array-index-key */

import { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';

import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import currencySign from 'utils/intl/currencySign.util';
import fixed from 'utils/values/fixed.util';

import { DownloadExcelButton } from 'reports/Common/DownloadExcelButton';
import { convertToMoneyAfterVat } from 'reports/utils';

import CN from './ProductSales.module.scss';

const ProductSales = ({ productSales, startDate, endDate, currentCurrencySign }) => {
  const { t } = useTranslation();
  const productsArr = asArray(productSales?.lastRequestResponse);

  const TABLE_HEADERS = useMemo(
    () => [t('businessReports.retail.productSalesByProductTableHeader1'), t('businessReports.retail.productSalesByProductTableHeader2'), t('businessReports.retail.productSalesByProductTableHeader3')],
    [t],
  );

  const createCsv = useCallback(
    () =>
      productsArr.map((product) => {
        const values = [
          product.product,
          product.sold,
          currencySign({
            value: fixed(convertToMoneyAfterVat(product.revenue)),
            currentSalonAbbr: currentCurrencySign,
          }),
        ];

        return TABLE_HEADERS.reduce((acc, header, index) => {
          acc[header] = values[index];
          return acc;
        }, {});
      }),
    [currentCurrencySign, productsArr, TABLE_HEADERS],
  );

  const hasTableData = fromAnyToBool(productsArr.length);

  return (
    <div id="retail-sales-by-product">
      <div className="t-bgr cfix">
        <div className="t-wrap">
          <div className={CN.tableHeader}>
            <h2>{t('businessReports.retail.productSalesByProductTitle')}</h2>
            <DownloadExcelButton getCsvData={createCsv} fileName={t('businessReports.retail.productSalesByProductFileName')} disabled={!hasTableData} />
          </div>
          <div className="t-discount cfix not-footer">
            <table className="discount-tbl" id="table-to-xls-4">
              <tbody>
                <tr>
                  <td colSpan="3">
                    <div className="date-in-tbl-for-export">
                      {t('businessReports.retail.fromDate')} <strong>{startDate}</strong>
                      {S.space}
                      {t('businessReports.retail.toDate')} <strong>{endDate}</strong>
                    </div>
                  </td>
                </tr>
                <tr className="t-h first-row">
                  <th className="a3 h" style={{ width: '168px' }}>
                    {TABLE_HEADERS[0]}
                  </th>
                  <th className="a3 text-r" style={{ width: '121px' }}>
                    <span className="bubble">
                      <span className="tooltip">
                        <div />
                      </span>
                    </span>
                    <span className="column-title">{TABLE_HEADERS[1]}</span>
                  </th>
                  <th className="a3 text-r" style={{ width: '121px' }}>
                    <span className="bubble">
                      <span className="tooltip">
                        <div />
                      </span>
                    </span>
                    <span className="column-title">{TABLE_HEADERS[2]}</span>
                  </th>
                  <th style={{ width: 'auto' }} />
                </tr>
                {productsArr.map((product, index) => (
                  <tr className="t-h" key={`${product.product}-${index}`}>
                    <td className="stylist-name">{product.product}</td>
                    <td className="t-value">{product.sold}</td>
                    <td className="t-value" style={{ paddingLeft: '34px' }}>
                      <CurrencySign />
                      {fixed(convertToMoneyAfterVat(product.revenue))}
                    </td>
                    <td />
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentCurrencySign: selectCurrentSalonCurrency(state),
});

export default connect(mapStateToProps)(ProductSales);
